import { create } from "zustand";

interface SellerVerificationUploadState {
  verificationId: string | null;
  nationalCardImage: Blob | null;
  selfieVideo: Blob | null;
  imageUploadProgress: number;
  videoUploadProgress: number;
  isUploading: boolean;
  uploadError: string | null;

  setVerificationId: (id: string) => void;
  setNationalCardImage: (blob: Blob) => void;
  setSelfieVideo: (blob: Blob) => void;
  setImageUploadProgress: (progress: number) => void;
  setVideoUploadProgress: (progress: number) => void;
  setIsUploading: (uploading: boolean) => void;
  setUploadError: (error: string | null) => void;
  reset: () => void;
}

const initialState = {
  verificationId: null,
  nationalCardImage: null,
  selfieVideo: null,
  imageUploadProgress: 0,
  videoUploadProgress: 0,
  isUploading: false,
  uploadError: null,
};

export const useSellerVerificationUpload =
  create<SellerVerificationUploadState>()((set) => ({
    ...initialState,

    setVerificationId: (id) => set({ verificationId: id }),
    setNationalCardImage: (blob) => set({ nationalCardImage: blob }),
    setSelfieVideo: (blob) => set({ selfieVideo: blob }),
    setImageUploadProgress: (progress) =>
      set({ imageUploadProgress: progress }),
    setVideoUploadProgress: (progress) =>
      set({ videoUploadProgress: progress }),
    setIsUploading: (uploading) => set({ isUploading: uploading }),
    setUploadError: (error) => set({ uploadError: error }),
    reset: () => set(initialState),
  }));
